import React from 'react'
import useOptionDropdownStyles from './useOptionDropdownStyles'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Container from '@material-ui/core/Container'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined'
import TooltipText from './TooltipText'
import useMenuTitleStyles from './useMenuTitleStyles'

const MenuItemComponent = props => {
    const {
        label,
        descriptionText,
        rightText,
        twoLines,
        multiSelect,
        selected = false,
        onClick = () => {},
        titleVariant,
        ...otherProps
    } = props
    const classes = useOptionDropdownStyles()
    const titleClass = useMenuTitleStyles()

    const handleClick = () => {
        onClick()
    }

    return (
        <MenuItem disableRipple className={titleVariant ? titleClass.titleRoot : classes.root} selected={selected} onClick={handleClick} {...otherProps}>
            {multiSelect && (
                <ListItemIcon className={classes.multiSelect}>
                    {selected ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankIcon />}
                </ListItemIcon>
            )}
            <Container className={classes.containerText} disableGutters>
                <TooltipText selectedClasses={titleVariant ? titleClass[titleVariant] : classes.optionText}>{label}</TooltipText>
                {descriptionText && 
                    <TooltipText selectedClasses={titleVariant ? titleClass.subTitle : (twoLines ? classes.descriptionTextTwoLines : classes.descriptionTextOneLine)}>
                        {descriptionText}
                    </TooltipText>
                }
            </Container>
            {rightText && <ListItemText className={classes.rightText} primary={rightText.charAt(0)} />}
        </MenuItem>
    )
}

export default MenuItemComponent
